import { Helmet } from 'react-helmet-async'

interface SeoProps {
  title?: string
  description?: string
  canonical?: string
  ogImage?: string
  noIndex?: boolean
}

export function Seo({
  title = 'Path Advisor',
  description = 'Kompleksowa platforma online z testami diagnozującymi',
  canonical = 'https://pathadvisor.pl',
  ogImage = 'https://app.pathadvisor.pl/logo.svg',
  noIndex = false
}: SeoProps) {
  const siteTitle = title

  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta content={description} name="description" />
      <link href={canonical} rel="canonical" />

      {/* Open Graph / Facebook */}
      <meta content="website" property="og:type" />
      <meta content={canonical} property="og:url" />
      <meta content={siteTitle} property="og:title" />
      <meta content={description} property="og:description" />
      <meta content={ogImage} property="og:image" />

      {/* Twitter */}
      <meta content="summary_large_image" name="twitter:card" />
      <meta content={canonical} name="twitter:url" />
      <meta content={siteTitle} name="twitter:title" />
      <meta content={description} name="twitter:description" />
      <meta content={ogImage} name="twitter:image" />

      {noIndex && <meta content="noindex, nofollow" name="robots" />}
    </Helmet>
  )
}
